/**
 * CargoPulse Expo - API client wrapper
 * Centralizes base URL, JWT injection, and role helpers.
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || '/api/v1';

const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (resp) => resp,
    (err) => {
        if (err.response?.status === 401 && !err.config?._retried) {
            // Best-effort silent refresh handled elsewhere by app shell
        }
        return Promise.reject(err);
    }
);

// Role helpers
export function getCurrentUser() {
    try { return JSON.parse(localStorage.getItem('user') || 'null'); }
    catch { return null; }
}

export function isSupervisorRole(role) {
    return ['ADMIN', 'MANAGEMENT'].includes(String(role || '').toUpperCase());
}

export function isStaffPlus(role) {
    return ['ADMIN', 'MANAGEMENT', 'STAFF', 'FINANCE', 'HR'].includes(String(role || '').toUpperCase());
}

export function getHubId() {
    return getCurrentUser()?.hub_id || getCurrentUser()?.hubId || null;
}

export default api;
